<template>
  <v-dialog v-model="dialog" width="90%">

    <v-card elevation="3">
      <div class="pp-sidenav">
        <v-card-title class="white--text">
          Edit an Awarding Body
        </v-card-title>

        <v-card-subtitle class="white--text">
          Amend details below
        </v-card-subtitle>
      </div>

      <v-img
          src="/images/pp-logo.png"
          height="40"
          contain
          class="logo-course"
      >
      </v-img>

      <v-tabs
          dark
          width="250"
          color="primary"
          vertical
      >
        <v-tab class="pp-sidenav-2">
          <v-icon left>
            mdi-pencil
          </v-icon>
          Edit an Awarding Body
        </v-tab>

        <v-tab-item>
          <v-card flat v-if="currentCertificationBodyItem">
            <v-container>
              <template>
                <v-card
                    color="grey lighten-4"
                    width="100%" flat
                >
                  <v-card-title class="text-h6 grey lighten-3">
                    Edit <span class="primary--text ml-2"> {{ currentCertificationBodyItem.name }} </span>
                    <v-icon class="ml-1">mdi-chevron-right</v-icon>
                  </v-card-title>

                  <v-card-text>
                    <div class="py-10 px-2">
                      <v-row>
                        <v-text-field
                            v-model="editableCertificationBodyItem.name"
                            label="Awarding Body Title"
                            aria-required="true"
                            color="primary"
                            placeholder="Edit Awarding Body Title"
                            prepend-icon="mdi-file-edit-outline"
                            flat
                            solo
                            clearable
                        ></v-text-field>
                      </v-row>
                      <v-row v-if="certificationBodyApiError && certificationBodyApiError.fields && certificationBodyApiError.fields.name"
                             class="err-text">
                        <p class="error--text">
                          Awarding Body name should not be empty and contain letters and/or numbers.
                        </p>
                      </v-row>

                      <v-row class="mb-5">
                        <v-textarea
                            v-model="editableCertificationBodyItem.description"
                            auto-grow
                            hint="The description of the Awarding Body will be publicly visible"
                            persistent-hint
                            label="Awarding Body Description"
                            aria-required="true"
                            color="primary"
                            placeholder="Edit Awarding Body Description"
                            prepend-icon="mdi-format-line-style"
                            flat
                            solo
                            clearable
                        ></v-textarea>
                      </v-row>

                      <v-row
                          v-if="certificationBodyApiError && certificationBodyApiError.fields && certificationBodyApiError.fields.description"
                          class="err-text">
                        <p class="error--text">
                          Awarding Body description should not be empty and contain letters and/or numbers.
                        </p>
                      </v-row>

                      <ImagePicker v-model="editableCertificationBodyItem.image"/>

                      <TagsInput
                          v-model="editableCertificationBodyItem.tags"
                          :validationError="certificationBodyApiError"
                      />

                      <v-row v-if="certificationBodyApiError">
                        <v-alert
                            text
                            color="red"
                            icon="mdi-alert-circle-outline"
                        >
                          There was an error in submission. Please check all fields and try again.
                        </v-alert>
                      </v-row>
                    </div>

                  </v-card-text>
                </v-card>
              </template>
            </v-container>
          </v-card>
          <div v-else>
            <UnavailableContent />
          </div>
        </v-tab-item>
      </v-tabs>

      <div class="pp-sidenav">
        <div class="btm">
          <Loading v-if="certificationBodyItemLoading"/>
          <ConfirmCancelButtons
              :item="currentCertificationBodyItem"
              :confirm-disabled="certificationBodyItemLoading"
              :confirm-action="editItemConfirm"
              :cancel-action="closeDialog"
              confirm-text="Save Changes"/>
        </div>
      </div>

    </v-card>
  </v-dialog>
</template>

<script>
import Loading from "@/components/common/Loading";
import ConfirmCancelButtons from "@/components/common/ConfirmCancelButtons";
import { mapActions, mapGetters } from "vuex";
import UnavailableContent from "@/components/common/UnavailableContent";
import ImagePicker from "@/components/common/ImagePicker";
import TagsInput from "@/components/common/TagsInput";

export default {
  name: "CertificationBodyEdit",
  components: {ImagePicker, TagsInput, UnavailableContent, Loading, ConfirmCancelButtons},
  computed: {
    ...mapGetters([
      'certificationBodyApiError', 'openDialog', 'currentCertificationBodyItem',
      'editableCertificationBodyItem', 'certificationBodyItemLoading',
    ]),
    dialog: {
      get () {
        return this.openDialog === 'certificationBodyEdit';
      },
      set(value) {
        this.setOpenDialog(value);
      },
    },
  },
  methods: {
    ...mapActions(['editCertificationBody', 'clearCertificationBodyItems', 'setOpenDialog', 'closeOpenDialog']),
    closeDialog() {
      this.closeOpenDialog();
      this.clearCertificationBodyItems();
    },
    async editItemConfirm() {
      const edited = await this.editCertificationBody(this.editableCertificationBodyItem);

      if (edited) {
        this.closeOpenDialog();
      }
    },
  },
};
</script>
